/**
 * กัน input[type="number"] เปลี่ยนค่าตอน scroll mousewheel ขณะ focus
 * ครอบทุก <input type="number"> ใน app โดยอัตโนมัติ
 */
export default defineNuxtPlugin(() => {
  const handler = (event: WheelEvent) => {
    const target = event.target as HTMLElement | null
    if (!target || target.tagName !== 'INPUT')
      return

    const input = target as HTMLInputElement
    if (input.type !== 'number')
      return

    if (document.activeElement !== input)
      return

    event.preventDefault()
    input.blur()
  }

  document.addEventListener('wheel', handler, { passive: false })
})
